import { type FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'Button';
import { Text } from 'Text';
import { showToast } from 'Toast';
import '../locales/streamDashboard/streamDashboard-en.json';

// Load failure other than "sign in first". A toast and retry, not a modal: there is no dashboard close action here.

type Props = {
    onRetry: () => void;
};

export const StreamDashboardLoadError: FC<Props> = ({ onRetry }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    // Once per mount. The branch only renders while the query is in its error state, so a retry that
    // fails again remounts this and announces the failure a second time, which is what we want.
    useEffect(() => {
        showToast({ message: t('server_error'), type: 'danger' });
    }, [t]);

    return (
        <div className="flex flex-col items-center gap-5 p-10">
            <Text as="p" weight="semibold" className="text-center text-lg text-black">
                {t('server_error')}
            </Text>

            <Button onPress={onRetry} color="black">
                {t('retry')}
            </Button>
        </div>
    );
};
